




























import Vue from 'vue'

import { Component, Prop, Watch, Emit } from 'vue-property-decorator'
import AppDialog from '@/components/AppDialog.vue'
import AppBreadcrumbs from '@/components/AppBreadcrumbs.vue'
import AppTableDate from '@/components/AppTableDate.vue'
import { Case } from '@/modules/Case/interfaces/case'
import { tablePerPageOptions } from '@/utils/tablePerPageOptions'
import { ApolloResponse } from '@/interfaces/apollo'
import { getCases } from '@/modules/Newcase/gql/case.gql'
import { showErrors } from '@/utils/snack'

@Component({
  components: {
    AppDialog,
    AppBreadcrumbs,
    AppTableDate
  }
})
export default class OpenCasesDialog extends Vue {
  @Prop({ type: Boolean }) readonly show!: boolean
  @Prop({ type: String }) readonly title!: string
  @Prop({ type: Number }) readonly accountId!: number

  showDialog = false

  caseTableColumn = [
    { field: 'id',
      title: 'Case ID',
      slots: { default: ({ row }: any, h: any) => {
        return [
          h('span', row.id ? row.id : '-')
        ]
      }
      },
      sortable: true,
      resizable: true,
      width: 120,
      fixed: 'left'
    },
    { field: 'inquiryName',
      title: 'Case Name',
      slots: { default: 'name_default' },
      resizable: true,
      sortable: true
    },
    { title: 'Creation Time',
      field: 'createdAt',
      slots: {
        default: 'time_default'
      },
      resizable: true,
      sortable: true
    },
    {
      title: 'Creator',
      field: 'createdBy',
      slots: {
        default: 'case_manager'
      },
      resizable: true,
      sortable: true
    }
  ]

  tableOptions = {
    loading: false,
    tablePage: tablePerPageOptions(),
    sortBy: 'id',
    sortDesc: true
  }

  orderBy: {
    [key: string]: string
  } = {
    id: 'ID',
    createdAt: 'CREATED_AT',
    caseName: 'CASE_NAME'
  }

  allCases: Case[] = []

  async getCases () {
    const { sortBy, sortDesc, tablePage } = this.tableOptions
    const { currentPage, pageSize } = tablePage
    const orderBy = this.orderBy[sortBy] || 'ID'
    this.tableOptions.loading = true
    try {
      const result: ApolloResponse = await this.$apollo.query({
        query: getCases,
        variables: {
          filter: {
            accountId: this.accountId
          },
          isTop: false,
          isOpen: true,
          paging: {
            offset: (currentPage - 1) * pageSize,
            limit: pageSize
          },
          order: {
            orderBy: orderBy,
            asc: !sortDesc
          }
        }
      })
      if (!result.data) {
        showErrors(result.errors)
        return
      }
      this.allCases = result.data.getCases.cases
      this.tableOptions.loading = false
      this.tableOptions.tablePage.total = result.data.getCases.paging.totalCount
    } catch (e) {
      showErrors(e.graphQLErrors)
    }
  }

  @Watch('show')
  async onShowChanged (val: boolean) {
    this.showDialog = val
    if (val) {
      this.getCases()
    }
  }

  sortTable (column: any) {
    this.tableOptions.sortBy = column.property
    this.tableOptions.sortDesc = column.order === 'desc'
    this.getCases()
  }

  handlePageChange (pageData: any) {
    this.tableOptions.tablePage.currentPage = pageData.currentPage
    this.tableOptions.tablePage.pageSize = pageData.pageSize
    this.getCases()
  }

  @Emit('cancel')
  handleCancel () {
    // do nothing
  }

  routeToCaseDetail (item: any) {
    this.$router.push({
      name: 'CaseDetailDetail',
      params: {
        id: item.id
      }
    })
  }
}
